module.exports = __webpack_public_path__ + "img/av263.cf36507f.png";